<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-book">
<h1>About the Book</h1>
<p>In her groundbreaking first book, author Eileen Ballman proves she herself is an ‘Everywoman’ in every sense of the word. By drawing on relatable, personal experiences such as childhood, growing pains, education, careers, marriage, parenthood, and gracefully aging, her exploration of the myriad ways women handle life’s milestones offers a compelling, evocative, and emotive read. Jesting she is Shakespeare’s sister, she quickly draws the reader into her stories and musings as she demonstrates her love of the “human condition”; the bond and friendship which develops between the author and the reader is immediate and gratifying. Her unique hybrid approach to memoir/self-help journaling will change how readers view these genres. Because she seeks the reader’s opinion of her own handling of various situations, the reader advances from the sidelines to the forefront. Encouraged to document their personal accounts on the pages provided, readers now find themselves an integral and valuable part of a storyline. As she tackles challenging subjects such as ‘How Far Will You Go’, ‘Loss of Innocence’, ‘Bouncing Back’, and ‘Defining Moments’, Ms. Ballman reveals her extensive knowledge of the complexity of life’s challenges, as well as her authentic compassion for the female role. Characterizing herself as an ‘Everywoman’, she notes, “Although we may not be prominent, notable figures ourselves, our universally relatable stories certainly are, and this ability to relate creates our impregnable bond.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch002.vue?632d89f6